import { API_DOMAIN } from '@Constants/config';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const RedirectPage: React.FC = () => {
  const { short_code } = useParams();
  const [countdown, setCountdown] = useState(3);
  const [originalUrl, setOriginalUrl] = useState<string | null>(null);

  useEffect(() => {
    let seconds = 3;
    const timer = setInterval(() => {
      seconds -= 1;
      setCountdown(seconds);
      if (seconds === 0) {
        clearInterval(timer);
        if (originalUrl) {
          window.location.href = originalUrl;
        }
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [originalUrl]); // starts countdown even before API finishes

  useEffect(() => {
    if (!short_code) return;

    const fetchOriginalUrl = async () => {
      try {
        const res = await fetch(`${API_DOMAIN}/v0/get_short_link/${short_code}`);
        const data = await res.json();

        if (res.status === 200 && data.original_url) {
          setOriginalUrl(data.original_url);
        } else {
          window.location.href = '/404';
        }
      } catch (error) {
        console.error('Failed to fetch original URL:', error);
        window.location.href = '/404';
      }
    };

    fetchOriginalUrl();
  }, [short_code]);

  return (
    <div  style={styles.container}>
    <div>
      <h1 className='' style={styles.countdown}>Redirecting in {countdown}...</h1>
    </div>
      <div style={styles.texts}>
        <div style={styles.subtext}>automation built with</div>

        <a href={`https://linkplease.co?utm_source=lp&utm_medium=lp_redirect&utm_content=${short_code}`} ><img
          style={styles.logo}
          src="https://www.app.linkplease.co/static/media/LinkPlease-full.a1f3b2fd161a0ba320f3.png"
          alt="LinkPlease Logo"
        /></a>
      </div>

    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundImage: 'url(https://www.app.linkplease.co/assests/bg.svg)',
    backgroundSize: 'cover',
    backgroundAttachment: 'fixed',
    color: '#333',
    textAlign: 'center',
  },
  logo: {
    maxWidth: '155px',
    width: '70%',
    margin: 'auto',
    marginBottom: '16px',
  },
  subtext: {
    fontSize: '16px',
    color: '#666',
    marginBottom: '2px',
    marginTop: '0.5vh'
  },
  countdown: {
    fontSize: '2rem',
    fontWeight: 600,
  },
  texts: {
    position: 'absolute',
    bottom: 25
  }
};

export default RedirectPage;
